import "./Showcase.css";
import Footer from "./Footer";

const Showcase = (props) => {
  return (
    <div className="showcase">
      <div className="text">
        {props.image === "itlandschap" && (
          <>
            <h1>IT-Landschap </h1>
            <p className="description">
              Samen met mijn collega’s heb ik een app ontwikkeld waarmee
              eenvoudig het IT-landschap van een bedrijf in kaart gebracht kan
              worden. De gebruiker kan de namen van servers invoeren en de
              applicaties die erop draaien. Ook geeft de gebruiker aan waarvoor
              deze applicaties worden gebruikt, wie de product owner ervan is
              etc. Applicaties en hun bijbehorende informatie worden in een
              database opgeslagen en in de frontend in een tabel weergegeven.
              Alle ingevoerde gegevens worden verbonden aan een specifiek, met
              wachtwoord beveiligd user-account. Applicaties in de tabel kunnen
              ook gefilterd worden, afhankelijk van wat de gebruiker wil zien.
              Het maken van de IT-landschap applicatie heeft me veel bijgebracht
              over het bouwen van een grotere applicatie, in samenwerking met
              anderen. We moesten taken afstemmen, zorgvuldig met onze branches,
              commits en pushes omgaan, en vooral ook goed elkaars code
              interpreteren. Dit om functionaliteiten bij te bouwen in delen van
              de app die niet door onszelf geschreven waren. Het werken met een
              grotere applicatie gaf onder andere de ervaring van data doorgeven
              aan componenten die zich in een volledig ander deel van de app
              bevonden en hoe je dit efficiënt en overzichtelijk moet doen.
              Tijdens het maken van de user account-functionaliteit van deze
              app, heb ik geleerd te werken met tokens, session en local storage
              en password encryption.
            </p>
            <button
              onClick={() =>
                window.open("https://gitlab.com/Reinaldinus/it-plaat-app")
              }
            >
              Bekijk repository
            </button>
          </>
        )}
        {props.image === "budget" && (
          <>
            <h1>Budget app </h1>
            <p className="description">
              In deze app kan de gebruiker een datum kiezen en op deze datum een
              uitgave noteren. Deze uitgave wordt dan weergegeven op de gekozen
              dag en opgeslagen in een MongoDB database. Uitgaves op
              verschillende data worden ook weergegeven in een automatisch
              gegenereerde lijngrafiek. De reikwijdte van de x- en de y-as van
              deze grafiek zijn afhankelijk van de maximale waarden van de
              gedane uitgaven, en de vroegste en laatste datum waarop een
              uitgave genoteerd is. Dit project was mijn eerste poging om
              individueel een full stack MERN applicatie te maken. MERN
              betekent: MongoDB, Express.js, React en Node.js. Al deze
              technologieën heb ik voor deze app dus gebruikt. Ik heb hiermee
              ervaring opgedaan met het maken van een eigen API (met Node en
              Express) die verbinding maakt met een eigen database (MongoDB).
              Het opstellen van de grafiek heb ik met D3.js gedaan. In
              retrospect had ik een eenvoudigere library kunnen gebruiken voor
              het tekenen van een simpele lijngrafiek, maar D3 sprak me aan in
              hoeverre je met groot detail data kan visualiseren.
            </p>
            <button
              onClick={() =>
                window.open("https://gitlab.com/Reinaldinus/budget-app")
              }
            >
              Bekijk repository
            </button>
          </>
        )}
        {props.image === "atoms" && (
          <>
            <h1>Atoms </h1>
            <p className="description">
              "Atoms" is het resultaat van tests die ik met Chat-GPT heb
              uitgevoerd. Ik heb een React-applicatie met D3.js opgezet, en ben
              vervolgens met Chat-GPT aan de slag gegaan om de applicatie te
              maken. Ik wilde graag zien hoe ver ik zou komen op basis van dit
              hulpmiddel. Het resultaat is een interessant visueel speeltje,
              waarvan enkele parameters door de gebruiker aangepast kunnen
              worden. De code die deze applicatie laat werken is dus grotendeels
              niet door mij geschreven. Ik heb echter wel de specifieke prompts
              geschreven waaruit deze code is ontstaan. Met dit project zocht ik
              de grenzen op van de bruikbaarheid van Chat-GPT als hulpmiddel.
            </p>
            <button onClick={() => window.open("https://atoms-b281d.web.app/")}>
              Bezoek website
            </button>
            <button
              onClick={() =>
                window.open("https://gitlab.com/Reinaldinus/atoms")
              }
            >
              Bekijk repository
            </button>
          </>
        )}
        {props.image === "quiz" && (
          <>
            <h1>Trivia </h1>
            <p className="description">
              Een applicatie die tien willekeurige vragen met bijbehorende goede
              en foute antwoorden ophaalt uit een open-source database. De
              gebruiker kan vervolgens deze multiple-choice vragen beantwoorden
              en na alle vragen beantwoord te hebben, ze laten checken. Bij tien
              correcte antwoorden springt confetti over het scherm. Bij het
              maken van deze applicatie heb ik geleerd gebruik te maken van
              API-calls in een React-applicatie en hoe ik de data die deze call
              ophaalt kan gebruiken om een user interface mee te maken.
            </p>
            <button
              onClick={() => window.open("https://trivia-d9f55.web.app/")}
            >
              Bezoek website
            </button>
            <button
              onClick={() =>
                window.open("https://gitlab.com/Reinaldinus/trivia")
              }
            >
              Bekijk repository
            </button>
          </>
        )}
        {props.image === "ety" && (
          <>
            <h1>Etymologie </h1>
            <p className="description">
              Een app die informatie ophaalt uit een open-source database met
              etymologische info. De gebruiker kan een woord in het zoekveld
              typen en als het woord in het woordenboek aanwezig is, verschijnt
              er informatie over de etymologische herkomst van het woord.
              Vervolgens zijn alle woorden in het zoekresultaat klikbaar, waarna
              het geklikte woord als nieuwe zoekterm wordt doorgegeven. Zo heb
              ik geprobeerd een soort Wikipedia-doorklik effect te creëren. Dit
              was eenzelfde soort technische oefening als beschreven in de
              travia applicatie: een API-call maken en de informatie op het
              scherm laten verschijnen.
            </p>
            <button
              onClick={() => window.open("https://etymology-3db86.web.app/")}
            >
              Bezoek website
            </button>
            <button
              onClick={() => window.open("https://gitlab.com/Reinaldinus/ety")}
            >
              Bekijk repository
            </button>
          </>
        )}
      </div>
      {props.image === "itlandschap" && (
        <img
          src={require("./Assets/itlandschap.png")}
          alt="IT-landschap app"
        ></img>
      )}
      {props.image === "budget" && (
        <img src={require("./Assets/Budget.png")} alt="Budget app"></img>
      )}
      {props.image === "quiz" && (
        <img src={require("./Assets/Quiz.png")} alt="Quiz app"></img>
      )}
      {props.image === "ety" && (
        <img
          src={require("./Assets/EtyAPP.png")}
          alt="ety-app"
          onClick={() => props.onClick("ety")}
        ></img>
      )}
      {props.image === "atoms" && (
        <img src={require("./Assets/Atomss.png")} alt="Atoms app"></img>
      )}
      <Footer />
    </div>
  );
};

export default Showcase;
